module.exports = require('./helpers/bundle-url').getBundleURL('6XXAY') + "assets/images/arrow-right.3008edf6.svg";